import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import ActionBarButton from '../ActionBarButton';
import s from './ActionBarEditButton.scss';
/**
 * Provides some some alternative hover styling compared to `ActionBarButton`.
 */
var ActionBarEditButton = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return React.createElement(ActionBarButton, __assign({ className: c(s['root'], className) }, rest));
};
ActionBarEditButton.displayName = 'ActionBarEditButton';
export default ActionBarEditButton;
//# sourceMappingURL=ActionBarEditButton.js.map